import React from "react";
import { motion } from "framer-motion";

const AnimatedImages = ({ images }) => {
  return (
    <div className="relative flex justify-center xl:top-[-4vw] items-center w-full min-h-[10vw] p-8 bg-gray-100">
      <div className="relative flex justify-center items-center w-full xs:max-w-[280px] sm:max-w-[400px] md:max-w-[500px] xl:max-w-[410px] 2xl:max-w-[600px] lg:w-3/4 lg:max-w-4xl">
        {images.map((image, index) => (
          <motion.img
            key={index}
            srcSet={image.srcSet}
            src={image.src}
            alt={image.alt}
            className={`absolute w-[70%] rounded-md shadow-lg z-10 transition-all duration-200 ${image.className}`}
            whileHover={{
              scale: 1.1,
              translateY: "-0.5rem",
              zIndex: 20,
              outline: "1.3rem solid #166534",
              boxShadow: "0 3rem 5rem rgba(0, 0, 0, 0.5)",
            }}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          />
        ))}
      </div>
    </div>
  );
};

export default AnimatedImages;
